import { render, staticRenderFns } from "./ModalExcluirProduto.vue?vue&type=template&id=48f525ec&scoped=true&"
import script from "./ModalExcluirProduto.vue?vue&type=script&lang=js&"
export * from "./ModalExcluirProduto.vue?vue&type=script&lang=js&"
import style0 from "./ModalExcluirProduto.vue?vue&type=style&index=0&id=48f525ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f525ec",
  null
  
)

export default component.exports